import { axiosInstance } from '../../api/api';
import * as ActionTypes from '../actionTypes';
import { updateReceivePart } from './receivePart';
import { updateCurrentLineItem } from './station';

export const submitMarkUnprocessed =
  (sequenceNumber, payload, successCallback, errorCallback) => () => {
    axiosInstance
      .post(`/station/parts/${sequenceNumber}/take-out`, { ...payload })
      .then(() => {
        successCallback();
      })
      .catch((err) => {
        // console.log('err', err);
        errorCallback(err);
      });
  };

export const getPartValidationDetailsForSerialNumber =
  (successCallback, errorCallback, serialNumber) => (dispatch) => {
    axiosInstance
      .get(`/station/part-validation/${serialNumber}`)
      .then(({ data }) => {
        const updatedScanJobDetails = data.scanJobDetails.map((scanJob) => {
          const scanJobResults = scanJob.scanJobResults.map((scanJobResult) => {
            return {
              ...scanJobResult,
              displaySerialNumber: scanJobResult.scannedSerialNumber,
            };
          });

          return { ...scanJob, scanJobResults };
        });
        const updatedData = { ...data, scanJobDetails: updatedScanJobDetails };
        dispatch(updatePartValidation({ ...updatedData, serialNumber }));
        successCallback(data);
      })
      .catch((err) => {
        errorCallback(err);
      });
  };

export const getProcessValidationDetailsForSerialNumber =
  (serialNumber, successCallback, errorCallback) => () => {
    // console.log("Thunk executed:", serialNumber);
    axiosInstance
      .get(`/station/process-validation/getStationOperations/${serialNumber}`)
      .then(({ data }) => {
        successCallback(data);
      })
      .catch((err) => {
        errorCallback(err);
      });
  };

export const getFeatures = (successCallback, errorCallback) => () => {
  axiosInstance
    .get('/features')
    .then(({ data }) => {
      successCallback(data);
    })
    .catch((err) => {
      errorCallback(err);
    });
};

export const getProcessValidationDetailsForVcNumber =
  (partNumber, successCallback, errorCallback) => () => {
    axiosInstance
      .get(`/station/process-validation/machine-operation/${partNumber}`)
      .then(({ data }) => {
        // Filter out objects with machineId === 50001
        const filteredData = Array.isArray(data)
          ? data.filter((item) => item.machineId !== 50001)
          : data;
        successCallback(filteredData);
      })
      .catch((err) => {
        errorCallback(err);
      });
  };



export const skipPartScanning =
  (sequenceNumber, payload, successCallback, errorCallback) =>
    (dispatch, getState) => {
      axiosInstance
        .post(`/station/part-validation/${sequenceNumber}/skip`, { ...payload })
        .then((response) => {
          const { partValidation } = getState();
          const { data } = response;

          const scanJobDetails = data.scanJobDetails.map((scanJob) => {
            if (scanJob.familyId === payload.familyId) {
              const scanJobResults = scanJob.scanJobResults.map(
                (scanJobResult, index) => {
                  if (index === scanJob.scanJobResults.length - 1) {
                    return {
                      ...scanJobResult,
                      displaySerialNumber: payload.scannedSerialNumber,
                    };
                  }
                  return {
                    ...scanJobResult,
                    displaySerialNumber: scanJobResult.scannedSerialNumber,
                  };
                },
              );

              return { ...scanJob, scanJobResults };
            }
            return { ...scanJob };
          });

          const updatedData = { ...partValidation, scanJobDetails };
          dispatch(updatePartValidation({ ...updatedData }));
          successCallback({ ...updatedData });
        })
        .catch((err) => {
          errorCallback(err);
        });
    };

export const validatePart =
  (sequenceNumber, payload, successCallback, errorCallback) =>
    (dispatch, getState) => {
      axiosInstance
        .post(`/station/part-validation/${sequenceNumber}/validate`, {
          ...payload,
        })
        .then((data) => {
          const { partValidation } = getState();
          const scanJobDetails = data.data.scanJobDetails.map((scanJob) => {
            if (scanJob.familyId === payload.familyId) {
              return { ...scanJob };
            }
            return { ...scanJob };
          });

          const updatedData = { ...partValidation, scanJobDetails };
          dispatch(updatePartValidation({ ...updatedData }));
          successCallback({ ...updatedData });
        })
        .catch((err) => {
          errorCallback(err);
        });
    };

export const revalidatePart =
  (sequenceNumber, idToUpdate, payload, successCallback, errorCallback) =>
    (dispatch, getState) => {
      const { partValidation } = getState();

      axiosInstance
        .post(
          `/station/part-validation/${sequenceNumber}/update-validation/${idToUpdate}`,
          {
            ...payload,
          },
        )
        .then((response) => {
          const { data } = response;

          const scanJobDetails = data.scanJobDetails.map((scanJob) => {
            if (scanJob.familyId === payload.familyId) {
              const scanJobResults = scanJob.scanJobResults.map(
                (scanJobResult) => {
                  if (scanJobResult.id === idToUpdate)
                    return {
                      ...scanJobResult,
                      scannedSerialNumber: payload.scannedSerialNumber,
                      displaySerialNumber: payload.scannedSerialNumber,
                      skipReason: null,
                    };
                  return { ...scanJobResult };
                },
              );

              return { ...scanJob, scanJobResults };
            }
            return { ...scanJob };
          });

          const updatedData = { ...partValidation, scanJobDetails };
          dispatch(updatePartValidation({ ...updatedData }));
          successCallback({ ...updatedData });
        })
        .catch((err) => {
          errorCallback(err);
        });
    };

export const bookSequenceNumber =
  (sequenceNumber, successCallback, errorCallback) => (dispatch) => {
    axiosInstance
      .post(`/station/book/${sequenceNumber}`)
      .then(() => {
        dispatch(updatePartValidation({}));
        dispatch(updateReceivePart({}));
        dispatch(updateCurrentLineItem(null));
        successCallback();
      })
      .catch((err) => {
        errorCallback(err);
      });
  };

export const updatePartValidation = (data) => (dipatch, getState) => {
  const { user } = getState();
  const { station } = user;

  const state = { ...data };

  const lineAndStationDataInLocalStorage =
    JSON.parse(localStorage.getItem(station.replaceAll(/[- ]/g, '_'))) || {};

  const lineAndStationData = {
    ...lineAndStationDataInLocalStorage,
    partValidation: state,
  };
  localStorage.setItem(
    station.replaceAll(/[- ]/g, '_'),
    JSON.stringify(lineAndStationData),
  );

  dipatch({
    type: ActionTypes.UPDATE_PART_VALIDATION,
    ...state,
  });
};

export const raiseExceptionRequest =
  (asn, payload, successCallback, errorCallback) => () => {
    axiosInstance
      .post(`/station/perform-privileged-action/${asn}`, { ...payload })
      .then(() => {
        successCallback();
      })
      .catch((err) => {
        errorCallback(err);
      });
  };
export const completeEngravingProcessValidation =
  (payload, successCallback, errorCallback) => () => {
    axiosInstance
      .post('/station/process-validation/engraving/complete', payload)
      .then(({ data }) => {
        successCallback(data);
      })
      .catch((err) => {
        errorCallback(err);
      });
  };

export const privilegedSkip =
  (asn, payload, successCallback, errorCallback) => (dispatch) => {
    axiosInstance
      .post(`/station/perform-privileged-action/${asn}/skip`, payload)
      .then(({ data }) => {
        successCallback(data);
      })
      .catch((err) => {
        errorCallback(err);
      });
  };